export default __webpack_public_path__ + "style-osm-night-800-91d826cb180ff91ffb2033cf74fdb4c6.webp";